import { useEffect, useState } from "react";
import {
  categoryColor,
  INACTIVE_COLOR,
  type CategoryWithServices,
} from "@shared/modules/x-atelier";
import { getCatalogue } from "../lib/api";

/**
 * Légende des couleurs de l'agenda : une pastille par catégorie de services,
 * plus le rouge des rendez-vous annulés ou manqués. C'est la clé de lecture de
 * l'horaire — sans elle, les couleurs ne disent rien. Les couleurs des
 * catégories se règlent dans Catalogue, celle d'un rendez-vous précis dans sa
 * fenêtre.
 */
export function ColorLegend() {
  const [categories, setCategories] = useState<CategoryWithServices[]>([]);

  useEffect(() => {
    let current = true;
    getCatalogue()
      .then((list) => {
        if (current) setCategories(list.filter((c) => c.services.length > 0));
      })
      .catch(() => {
        if (current) setCategories([]);
      });
    return () => {
      current = false;
    };
  }, []);

  if (categories.length === 0) return null;
  return (
    <ul className="color-legend" aria-label="Couleurs des services">
      {categories.map((c) => (
        <li key={c.id} className="color-legend__item">
          <span
            className="color-legend__dot"
            style={{ background: categoryColor(c) }}
            aria-hidden="true"
          />
          {c.name}
        </li>
      ))}
      <li className="color-legend__item">
        <span
          className="color-legend__dot"
          style={{ background: INACTIVE_COLOR }}
          aria-hidden="true"
        />
        Annulé ou absent
      </li>
    </ul>
  );
}
